/**
 * A person's sex. primary owns this vocabulary. The name distinguishes it from primary's older
 * lower-cased `Sex` enum, which is being retired in its favour.
 */
export var SexUpper;
(function (SexUpper) {
    SexUpper["Female"] = "FEMALE";
    SexUpper["Male"] = "MALE";
    SexUpper["NonBinary"] = "NON_BINARY";
    SexUpper["Other"] = "OTHER";
    SexUpper["Transgender"] = "TRANSGENDER";
    SexUpper["TransgenderFemale"] = "TRANSGENDER_FEMALE";
    SexUpper["TransgenderMale"] = "TRANSGENDER_MALE";
    SexUpper["Unknown"] = "UNKNOWN";
})(SexUpper || (SexUpper = {}));
//# sourceMappingURL=sex.js.map